import type { Operaciones } from '../../../api/operaciones';

/** Nombre del archivo de la plantilla: `plantilla-clientes-<slug>.csv`. */
function nombrePlantilla(slug: string | undefined): string {
    return `plantilla-clientes${slug === undefined || slug === '' ? '' : `-${slug}`}.csv`;
}

/** «Descargar plantilla» (getCustomerImportTemplate, G149): el CSV con los campos propios del negocio, como archivo. */
export function descargarPlantilla(ops: Operaciones, negocio: string, slug: string | undefined): Promise<void> {
    return ops.getCustomerImportTemplate(negocio).then((csv) => {
        if (typeof URL.createObjectURL !== 'function') {
            return;
        }
        const enlace = document.createElement('a');
        enlace.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
        enlace.download = nombrePlantilla(slug);
        document.body.appendChild(enlace);
        enlace.click();
        enlace.remove();
        URL.revokeObjectURL(enlace.href);
    });
}
